import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

import admins from './modules/admins';
import authentication from './modules/authentication';
import calculator from './modules/calculator';
import costRules from './modules/costRules';
import deliveryServices from './modules/deliveryServices';
import payments from './modules/payments';
import promocodes from './modules/promocodes';
import shops from './modules/shops';
import tariffLoading from './modules/tariffLoading';
import users from './modules/users';
import ordersTransfer from './modules/ordersTransfer';

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: true,

    state: {
        openedMenuItem: null,
        localStorage: {
            selectedShop: {
                number: 1,
                name: ''
            },
            deliveryMethodCities: {
                searchQuery: '',
                method: {
                    deliveryMethodId: null,
                    deliveryMethodName: ''
                }
            },
            editedPromocode: {},
            editedCostRule: {},
            editedShop: {},
            editedDeliveryMethod: {},

            isDarkMode: false
        }
    },

    mutations: {
        selectMenuItem(state, name) {
            state.openedMenuItem = name;
        },
        selectShop(state, shop) {
            state.localStorage.selectedShop = shop;

            state.deliveryServices.loaded = false;
        },
        changeCitiesListSearchQuery(state, {name}) {
            state.localStorage.deliveryMethodCities.searchQuery = name;
        },
        changeSelectedDeliveryMethod(state, method) {
            state.localStorage.deliveryMethodCities.method = method;
        },
        changeEditedPromocode(state, promocode) {
            state.localStorage.editedPromocode = promocode;
        },
        changeEditedCostRule(state, costRule) {
            state.localStorage.editedCostRule = costRule;
        },
        changeEditedShop(state, shop) {
            state.localStorage.editedShop = shop;
        },
        switchThemeMode(state) {
            state.localStorage.isDarkMode = !state.localStorage.isDarkMode;
        }
    },

    actions: {

    },

    modules: {
        admins,
        authentication,
        calculator,
        costRules,
        deliveryServices,
        payments,
        promocodes,
        shops,
        tariffLoading,
        users,
        ordersTransfer
    },

    plugins: [
        createPersistedState({
            paths: [ 'localStorage' ]
        })
    ]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js